import { ITimeZone } from './../../shared/models/settings.model';
import produce from 'immer';
import * as fromActions from './settings.actions';
import { IAsyncData } from '@signal/asp-data-commons';

export interface SettingsState {
    settings: any,
    loading: boolean,
    loaded: boolean,
    error: string,
    department: string,
    timezones: ITimeZone[],
    zipcodes: IAsyncData<string[]>,
}

const initialState: SettingsState = {
    settings: {},
    loading: false,
    loaded: false,
    error: '',
    department: '',
    timezones: [],
    zipcodes: {
        data: [],
        loading: false,
        loaded: false,
        error: ''
    }
};

export function settingsReducer(state: SettingsState = initialState,
    action: fromActions.SettingsActions): SettingsState {

    switch (action.type) {
        case fromActions.SettingsActionTypes.LOAD_SETTINGS: {
            return produce(state, draftState => {
                draftState.settings = null;
                draftState.loaded = false;
                draftState.loading = true;
                draftState.department = action instanceof fromActions.LoadSettings ? action.payload.department : '';
                draftState.error = '';
            });
        }
        case fromActions.SettingsActionTypes.LOAD_SETTINGS_SUCCESS: {
            return produce(state, draftState => {
                draftState.settings = action instanceof fromActions.LoadSettingsSuccess ? action.payload.settings : {};
                draftState.loaded = true;
                draftState.loading = false;
                draftState.error = '';
            });
        }
        case fromActions.SettingsActionTypes.LOAD_SETTINGS_FAILURE: {
            return produce(state, draftState => {
                draftState.settings = {};
                draftState.loaded = true;
                draftState.loading = false;
                draftState.error = action instanceof fromActions.LoadSettingsFailure ? action.payload.error : '';
            });
        }

        case fromActions.SettingsActionTypes.LOAD_ZIPCODES: {
            return produce(state, draftState => {
                draftState.zipcodes = {
                    data: [],
                    loaded: false,
                    loading: true,
                    error: ''
                }
            });
        }
        case fromActions.SettingsActionTypes.LOAD_ZIPCODES_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadZipcodesSuccess ? action.payload : undefined;
                draftState.zipcodes = {
                    data: payload.zipcodes,
                    loaded: true,
                    loading: false,
                    error: ''
                }
            });
        }
        case fromActions.SettingsActionTypes.LOAD_ZIPCODES_FAILURE: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.LoadSettingsFailure ? action.payload : undefined;
                draftState.zipcodes = {
                    data: [],
                    loaded: false,
                    loading: true,
                    error: payload.error
                }
            });
        }

        case fromActions.SettingsActionTypes.UPDATE_SETTINGS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateSettings ? action.payload : null;
                draftState.loaded = false;
                draftState.settings = payload.settings;
                draftState.loading = true;
                draftState.error = '';
            });
        }
        case fromActions.SettingsActionTypes.UPDATE_SETTINGS_SUCCESS: {
            return produce(state, draftState => {
                const payload = action instanceof fromActions.UpdateSettingsSuccess ? action.payload : null;
                draftState.loaded = true;
                draftState.settings = payload.settings;
                draftState.loading = false;
                draftState.error = '';
            });
        }
        case fromActions.SettingsActionTypes.UPDATE_SETTINGS_FAILURE: {
            return produce(state, draftState => {
                draftState.loaded = true;
                draftState.settings = state.settings;
                draftState.loading = false;
                draftState.error = action instanceof fromActions.UpdateSettingsFailure ? action.payload.error : '';
            });
        }
        case fromActions.SettingsActionTypes.LOAD_TIMEZONES: {
            return produce(state, draftState => {
                draftState.loaded = true;
                draftState.timezones = [];
                draftState.loading = false;
                draftState.error = '';
            });
        }
        case fromActions.SettingsActionTypes.LOAD_TIMEZONES_SUCCESS: {
            return produce(state, draftState => {
                draftState.loaded = true;
                draftState.timezones = action instanceof fromActions.LoadTimezonesSuccess ? action.payload.timezones : [];
                draftState.loading = false;
                draftState.error = '';
            });
        }
        default:
            return state;
    }
}
